export const LOADING_START = "LOADING_START";
export const LOADING_STOP = "LOADING_STOP";
export const SHOW_CALLING_NUMBER_DIALOG = "SHOW_CALLING_NUMBER_DIALOG";
export const HIDE_CALLING_NUMBER_DIALOG = "HIDE_CALLING_NUMBER_DIALOG";
export const SAVING_HAISAI_CITIZEN_SECTION_SERVICE_ONE = "SAVING_HAISAI_CITIZEN_SECTION_SERVICE_ONE";
export const SAVING_NATIONAL_HEALTH_INSURANCE_SECTION = "SAVING_NATIONAL_HEALTH_INSURANCE_SECTION";
export const SAVING_CITIZEN_LIFE_SAFETY_SECTION = "SAVING_CITIZEN_LIFE_SAFETY_SECTION";
export const SAVING_HAISAI_CALLING_NUMBERS = "SAVING_HAISAI_CALLING_NUMBERS";
export const SAVING_HAISAI_CALLING_NUMBERS_ERROR = "SAVING_HAISAI_CALLING_NUMBERS_ERROR";
export const SAVING_HAISAI_CALLING_NUMBERS_ERROR_RESET = "SAVING_HAISAI_CALLING_NUMBERS_ERROR_RESET";